import { render } from "./suspended-comp.vue?vue&type=template&id=fb741f3c&scoped=true"
import script from "./suspended-comp.vue?vue&type=script&lang=js"
export * from "./suspended-comp.vue?vue&type=script&lang=js"

import "./suspended-comp.vue?vue&type=style&index=0&id=fb741f3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb741f3c"]])

export default __exports__